<template>
    <div>
        <div class="flex">
            <div class="col-10" v-if="tempProposal.selected_proposal_type">
                <proposal-generator-introduction v-if="section.tag.substring(0, 12) === 'introduction'"
                                                 @introductionChanged="introductionChanged"
                                                 :section="section"
                                                 :team="team"
                                                 :proposal="proposal"
                                                 :role="role"
                                                 :selected-template-object="selectedTemplateObjectSection"
                                                 :temp-proposal="tempProposal"></proposal-generator-introduction>
                <proposal-generator-cover-selection v-else-if="section.tag.substring(0, 5) === 'title' && proposalCoverOptions.all_cover == 0"
                                        @titleChanged="titleChanged"
                                        :section="section"
                                        :team="team"
                                        :proposal="proposal"
                                        :selected-resource-file="selectedResourceFile"
                                        :select-cover-page-template="selectCoverPageTemplate"
                                        :proposal-cover-options="proposalCoverOptions"
                                        :selected-proposal-type="selectedProposalType"
                ></proposal-generator-cover-selection>
                    <proposal-generator-inspection v-else-if="section.tag.substring(0, 10) === 'inspection'"
                                               @inspectionChanged="inspectionChanged"
                                               :section="section"
                                               :team="team"
                                               :proposal="proposal"></proposal-generator-inspection>
                <proposal-generator-authorization v-else-if="section.tag.substring(0, 13) === 'authorization'"
                                                  @authorizationChanged="authorizationChanged"
                                                  :section="section"
                                                  :team="team"
                                                  :proposal="proposal"></proposal-generator-authorization>
                <proposal-generator-terms-and-conditions v-else-if="section.tag.substring(0, 20) === 'terms-and-conditions'"
                                                         @termsAndConditionsChanged="termsAndConditionsChanged"
                                                         :section="section"
                                                         :team="team"
                                                         :proposal="proposal"
                                                         :role="role"
                                                         :selected-template-object="selectedTemplateObjectSection"
                                                         :temp-proposal="tempProposal"></proposal-generator-terms-and-conditions>
                <proposal-generator-custom-section v-else
                                                   @customSectionChanged="customSectionChanged"
                                                   @deleteSection="deleteSection"
                                                   :section="section"
                                                   :team="team"
                                                   :proposal="proposal"
                                                   :role="role"
                                                   :selected-template-object="selectedTemplateObjectSection"
                                                   :temp-proposal="tempProposal"
                                                   ref="customSectionRef"
                                                   :selected-proposal-type="selectedProposalType"
                                                   :formatted-sales-taxes-for-quote="formattedSalesTaxesForQuote"
                                                   :quote-comment-templates="quoteCommentTemplates"
                                                   :user="user"
                                                   :all-custom-signatures="allCustomSignatures"
                ></proposal-generator-custom-section>
            </div>
            <div class="col-10" v-else>
                <div class="">
                    <div>
                        <div class="text-2xl bg-primary border-b-2 border-followup-nav px-3 py-2 text-white section-title overflow-hidden"></div>
                        <div class="col-12 card bg-white shadow mr-2">
                            <h4 class="text-center p-10">Please select a proposal template.</h4>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-2 preview p-0 m-0" style="height: 100vh; overflow: scroll;">
                <proposal-right-sidebar :section="section"
                                        :proposal="proposal"
                                        :role="role"
                                        :user="user"
                                        :team="team"
                                        :active-team-users="activeTeamUsers"
                                        :masks="masks"
                                        :symbols="symbols"
                                        :exchange="exchange"
                                        :externalEmailService="externalEmailService"
                                        :project="project"
                >
                </proposal-right-sidebar>
            </div>
        </div>
    </div>
</template>

<script>

    import ProposalRightSidebar from "./proposal-right-sidebar";
    import ProjectContactModal from "../project/external-email/project-contact-modal.vue";
    export default {
        components: {ProjectContactModal, ProposalRightSidebar},
        props: ['section', 'proposal', 'team','selectedResourceFile','role','selectCoverPageTemplate','selectedTemplateObject','tempProposal','proposalCoverOptions', 'user', 'selectedProposalType', 'formattedSalesTaxesForQuote', 'quoteCommentTemplates', 'activeTeamUsers', 'masks', 'symbols', 'exchange', 'externalEmailService', 'project', 'selectedProposalType'],
        data(){
            return {
                selectedTemplateObjectSection:this.selectedTemplateObject,
                allCustomSignatures: [],
            }
        },
        methods: {
            deleteSection(tag) {
                this.$emit('deleteSection', tag);
            },
            introductionChanged(introduction, showMessage = true) {
                this.$emit('introductionChanged', introduction, showMessage);
            },
            titleChanged(title) {
                this.$emit('titleChanged', title);
            },
            inspectionChanged(inspection) {
                this.$emit('inspectionChanged', inspection);
            },
            quoteDetailsChanged(quoteDetails) {
                this.$emit('quoteDetailsChanged', quoteDetails);
            },
            authorizationChanged(authorization) {
                this.$emit('authorizationChanged', authorization);
            },
            termsAndConditionsChanged(termsAndConditions, showMessage = true) {
                this.$emit('termsAndConditionsChanged', termsAndConditions, showMessage);
            },
            customSectionChanged(customSection, showMessage = true) {
                this.$emit('customSectionChanged', customSection, showMessage);
            }
        },
        mounted() {
            Bus.$on('selectCoverImage', data => {
                Bus.$emit('selectedResourceFile', data);
            });

            Bus.$on('selectCoverPageTemplateChild', data => {
                Bus.$emit('selectCoverPageTemplateParent', data);
            });
            Bus.$on('selectedTemplateObjectEmit', data => {
                Bus.$emit('selectedTemplateObjectEmitParent', data);
            });
            Bus.$on('fetchLatestResourceFileCall', data => {
                Bus.$emit('fetchLatestResourceFile', data);
            });
            Bus.$on('removeSelectedCoverImageOnDeletion', data => {
                Bus.$emit('removeSelectedCoverImageOnDeletionChild', data);
            });
            Bus.$on('coverOptionsParent', data => {
                Bus.$emit('coverOptions', data);
            });
            Bus.$on('saveNameFetchTemplatesParent', data => {
                Bus.$emit('saveNameFetchTemplates', data);
            });
            Bus.$on('assignTemplateGroupParent', data => {
                Bus.$emit('assignTemplateGroup', data);
            });
            Bus.$on('sectionProposalTemplateGroupChanged', data => {
                Bus.$emit('sectionProposalTemplateGroupChangedParent', data);
            });
            Bus.$on('refetchTemplateWhenTemplateGroupUnassignedParent', data => {
                Bus.$emit('refetchTemplateWhenTemplateGroupUnassigned', data);
            });
            Bus.$on('refreshResourcesSideBarParent', data => {
                Bus.$emit('refreshResourcesSideBar', data);
            });
            Bus.$on('updateSectionForHeaderFooterImageSection', data => {
                Bus.$emit('updateSectionForHeaderFooterImageParent', data);
            });
            Bus.$on('allCustomSignatures1', data => {
                this.allCustomSignatures = data;
            });

        }
    }
</script>
